import { useTranslation } from 'react-i18next';

// TODO: this should be defined like the following line but temporarily I need to change it until all the models are updated
// export const useActiveStatus = (state: string | undefined = ''): string => {
export const useActiveStatus = (
  state: string | boolean | undefined = undefined,
): string => {
  const { t } = useTranslation('common');

  if (typeof state === 'string')
    return state === 'active' ? t('common.active') : t('common.inactive');

  return state ? t('common.active') : t('common.inactive');
};
